"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "setNumberRegex", {
  enumerable: true,
  get: function () {
    return _utils.setNumberRegex;
  }
});
_Object$defineProperty(exports, "setValidateCallback", {
  enumerable: true,
  get: function () {
    return _utils.setValidateCallback;
  }
});
exports.useValidation = useValidation;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _react = require("react");
var _creators = require("./creators");
var _hooks = require("./hooks");
var _utils = require("./utils");
var _validationReducer = _interopRequireDefault(require("./validation-reducer"));
/**
 * We're tracking relevant DOM info with mutable ref objects: https://reactjs.org/docs/hooks-reference.html#useref
 * And we only trigger a re-render (useState forceUpdate) when UI state needs to change (errorState, formState).
 * @param   {object}    configurationOptions
 * @returns {object}
 */
function useValidation(configurationOptions) {
  const stateInitializer = (0, _react.useCallback)(options => (0, _utils.initializeReducerState)(options), [configurationOptions]);
  const {
    getState,
    dispatch
  } = (0, _hooks.useRefReducer)(_validationReducer.default, stateInitializer(configurationOptions));
  const {
    inputStates,
    isFormModified
  } = getState();
  const debouncedReconcile = (0, _debounce2.default)((0, _creators.reconcileElementsCreator)(getState, dispatch));
  const errors = (0, _utils.getErrors)(inputStates);
  return {
    // UI state objects
    errors,
    isFormModified,
    isFormValid: (0, _isEmpty2.default)(errors),
    // Hook toolkit methods
    getValues: (0, _creators.getValuesCreator)(getState),
    register: (0, _creators.registerCreator)(getState, dispatch, debouncedReconcile, (0, _creators.formEventHandlerCreator)(getState, dispatch)),
    reset: (0, _creators.resetCreator)(dispatch),
    setErrors: (0, _creators.setErrorsCreator)(getState, dispatch),
    validate: (0, _creators.validateCreator)(getState, dispatch),
    watch: (0, _creators.watchCreator)(getState, dispatch)
  };
}